import { render, staticRenderFns } from "./BomUpload.vue?vue&type=template&id=123988ea&scoped=true&"
import script from "./BomUpload.vue?vue&type=script&lang=js&"
export * from "./BomUpload.vue?vue&type=script&lang=js&"
import style0 from "./BomUpload.vue?vue&type=style&index=0&id=123988ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123988ea",
  null
  
)

export default component.exports